export default {
    'name': 'tif',
    'width': '88',
    'height': '76',
    'viewBox': '0 0 76 88',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M0 23.2409V80H71.1111V0H22.4796L0 23.2409Z\' fill=\'#006CFD\'/><rect width=\'39\' height=\'23\' transform=\'translate(37 49)\' fill=\'#C1E8FD\'/><path d=\'M49.5795 66V57.642H46.3175V56.2H54.6335V57.642H51.3435V66H49.5795ZM56.2513 66V56.2H58.0153V66H56.2513ZM60.7187 66V56.2H67.4667V57.642H62.4827V60.666H66.8367V62.108H62.4827V66H60.7187Z\' fill=\'#0158CE\'/>'
}
